import { DOCUMENT, isPlatformServer, TitleCasePipe } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '../../express.tokens';
import { Request } from 'express';
import { environment } from 'src/environments/environment';
import { InitialDataService } from './initialData.service';
import { constants } from '@syntonize/merlin-core';

@Injectable({
  providedIn: 'root',
})
export class TenantConfService {
  public language: string;

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) protected request: Request,
    private titleCasePipe: TitleCasePipe,
    private initialDataService: InitialDataService
  ) {}

  getTenantFromUrl() {
    let host;
    if (isPlatformServer(this.platformId)) {
      host = this.request.headers.referer || 'localhost:4200';
      if (host.includes('http')) {
        host = host.split('/')[2];
      }

      return environment.tenantByUrl[host];
    } else {
      return environment.tenantByUrl[window.location.host];
    }
  }

  public getOnlyLanding() {
    return environment.tenants[this.getTenantFromUrl()].onlyLanding;
  }

  public getTenantCookieScript() {
    return environment.tenants[this.getTenantFromUrl()].cookieScript;
  }

  public getTenantCookieDeclarationScript() {
    return environment.tenants[this.getTenantFromUrl()].cookieDeclarationScript;
  }

  getLanguage() {

    const language = this.document.location.pathname.split('/')[1] ?? this.getTenantDefaultLanguage()

    if (this.getTenantAvailableLanguages().includes(language)) {
      this.language = language;
    } else {
      this.language = this.getTenantDefaultLanguage();
    }

    localStorage.setItem(constants.storage.language, this.language);
    return this.language;
  }

  public getTenantAvailableLanguages() {
    return environment.tenants[this.getTenantFromUrl()].allowedLanguages;
  }

  public getTenantDefaultLanguage() {
    return environment.tenants[this.getTenantFromUrl()].allowedLanguages[0];
  }

  getTenantName() {
    const tenantName = this.getTenantFromUrl();
    return this.titleCasePipe.transform(tenantName);
  }

  getTenantNameNoCapitalize() {
    return this.initialDataService.tenant.getValue().publicName;
  }

  getEmploymentLink() {
    return environment.tenants[this.getTenantFromUrl()].employment;
  }

  getBlogUrl() {
    return environment.tenants[this.getTenantFromUrl()].blogUrl;
  }

  blogHasCustomPlugin() {
    return environment.tenants[this.getTenantFromUrl()].blogHasCustomPlugin;
  }

  hasCinema() {
    return environment.tenants[this.getTenantFromUrl()].hasCinema;
  }

  hasOnlyRestoration() {
    return environment.tenants[this.getTenantFromUrl()].hasOnlyRestoration;
  }

  hasSubcategories() {
    return !environment.tenants[this.getTenantFromUrl()].hasNoSubcategories;
  }

  getFooterLogoURL() {
    return environment.tenants[this.getTenantFromUrl()].footerLogoURL;
  }

  getMetadata() {
    return environment.tenants[this.getTenantFromUrl()].metadata;
  }

  getGTMId() {
    return environment.tenants[this.getTenantFromUrl()].gtm_id;
  }

  getFidelityCardName() {
    return environment.tenants[this.getTenantFromUrl()].fidelityCardName;
  }

  getFidelityCardUrl() {
    return environment.tenants[this.getTenantFromUrl()].fidelityCardUrl;
  }

  getShouldFitToBounds() {
    return environment.tenants[this.getTenantFromUrl()].shouldFitToBounds;
  }

  getZoomLevel() {
    return environment.tenants[this.getTenantFromUrl()].zoomLevel;
  }

  isActiveLanding() {
    return environment.tenants[this.getTenantFromUrl()].isActiveLanding !== undefined && environment.tenants[this.getTenantFromUrl()].isActiveLanding;
  }

}
